define(function (require) {
    "use strict";

    var Backbone = require('backbone');
    var AppConfig = require('config/application');

    var send = function(request, method) {
        method = method || 'call';

        return Backbone.ajax({
            url: AppConfig.host + '/rest/contacts/' + method,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(request),
        })
    }

    return {
        send: send
    }
})